import Swiper from 'swiper/bundle';

if ($(".slider-type-4.swiper-container").length > 0) {
    const slider_type_4_swiper = new Swiper(".slider-type-4.swiper-container", {
        slidesPerView: 'auto',
        loop: false,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        navigation: {
            nextEl: ".section-slider-type-4 .swiper-button-next.slider-type-4-swiper-button",
            prevEl: ".section-slider-type-4 .swiper-button-prev.slider-type-4-swiper-button",
        },
        pagination: {
            el: ".section-slider-type-4 .swiper-pagination",
            clickable: true,
        },

    });
}